import { CategoryChartQueryFn, CategoryChartQueryParam } from "../categoryChart";
import { FigureHorStackBarKpiProviders, FigureKpiProviders } from "./categoryChartData.types";
import { fetchFigureHorStackBarKpiComparisonChartData } from "./fetchFigureHorStackBarKpiComparisonChartData";

export const fetchSumFigureComparisonChartData: CategoryChartQueryFn = async (
    args: CategoryChartQueryParam
): Promise<FigureKpiProviders> => {
    const chart = (await fetchFigureHorStackBarKpiComparisonChartData(args)) as FigureHorStackBarKpiProviders;

    return {
        figures: chart?.elements?.map(element => {
            return [
                {
                    header: element?.figure?.header,
                    value: element?.figure?.value,
                    decimals: element?.figure?.decimals,
                    unit: element?.figure?.unit,
                    footer: element?.figure?.footer
                }
            ];
        }),
        footer: chart?.footer,
        title: chart?.title,
        waterProviders: chart?.waterProviders
    };
};
